import { shaparakService } from "@/common/api.service"

const initialStates = {
    status: 'loading',
    shop_shaparak_requests: [],
    shaparak_requests: {},
    shop_shaparak_requests_status: {},
    shaparak_info_tab : false
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    loadingShopShaparakRequests(state) {
        state.shop_shaparak_requests_status = "loading"
        state.shop_shaparak_requests = {}
    },
    successShopShaparakRequests(state, shaparak_requests) {
        state.shop_shaparak_requests_status = 'success'
        state.shop_shaparak_requests = shaparak_requests
    },
    setShaparakRequests(state, $data) {
        state.shaparak_requests = $data
    },
    setShaparakInfoTab(state, $data) {
        state.shaparak_info_tab = $data
    }
}

const getters = {
    status: ({status}) => status,
    shop_shaparak_requests_status: ({shop_shaparak_requests_status}) => shop_shaparak_requests_status,
    shop_shaparak_requests: ({shop_shaparak_requests}) => shop_shaparak_requests,
    shaparak_requests: ({shaparak_requests}) => shaparak_requests,
    shaparak_info_tab: ({shaparak_info_tab}) => shaparak_info_tab,
}

const actions = {
    fetchShopShaparakRequests({commit}, {hashid, is_starshop = false}) {
        commit('loadingShopShaparakRequests')
        return shaparakService.fetchShaparak(hashid, is_starshop).then(response => {
            commit('successShopShaparakRequests', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}